import React, { lazy } from 'react'

// const AutoNumberingForm = lazy(() =>
//   import(
//     '../../../GeneralSettingModule/AutoNumberingwDnD/AutoNumberingForm'
//   ).then(module => ({
//     default: module.AutoNumberingForm,
//   }))
// )

const AutoNumberingForm = lazy(() =>
  import('./AutoNumberingForm').then(module => ({
    default: module.AutoNumberingForm,
  }))
)

const autoNumberingRoutes = [
  {
    props: {
      exact: true,
      path:
        '/general-ledger/:CompanyID/company-setting/numbering-structure/journal-processing',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="journal-processing"
        pageMode="general-ledger"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-ledger/:CompanyID/company-setting/numbering-structure/external-journal',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="external-journal"
        pageMode="general-ledger"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-ledger/:CompanyID/company-setting/numbering-structure/recurring-journal',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="recurring-journal"
        pageMode="general-ledger"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-ledger/:CompanyID/company-setting/numbering-structure/audit-adjustment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="audit-adjustment"
        pageMode="general-ledger"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-ledger/:CompanyID/company-setting/numbering-structure/invoice-amortisation',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="invoice-amortisation"
        pageMode="general-ledger"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: '/cash-book/:CompanyID/company-setting/numbering-structure/payment',
    },
    component: (
      <AutoNumberingForm mode="add" DocType="paymentCb" pageMode="cash-book" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/cash-book/:CompanyID/company-setting/numbering-structure/receipt',
    },
    component: (
      <AutoNumberingForm mode="add" DocType="receipt" pageMode="cash-book" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/cash-book/:CompanyID/company-setting/numbering-structure/bank-transfer',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="bank-transfer"
        pageMode="cash-book"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/advance',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="advance"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/invoice',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="invoice"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/credit-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="credit-note"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/creditor-credit-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="creditor-credit-note"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/debit-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="debit-note"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/payment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="paymentAp"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/refund',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="refund"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/self-billed',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="self-billed"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-payable/:CompanyID/company-setting/numbering-structure/consolidate-self-billed',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="consolidate-einvoice"
        pageMode="account-payable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/invoice',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="invoice"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/credit-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="credit-note"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/debit-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="debit-note"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/official-receipt',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="official-receipt"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/advance',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="advance"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/refund',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="refund"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/interest',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="interest"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/consolidate-einvoice',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="consolidate-einvoice"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/company-setting/numbering-structure/proforma-invoice',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="proforma-invoice"
        pageMode="account-receivable"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-receipt',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-receipt"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-issue',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-issue"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-transfer',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-transfer"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/cycle-counting',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="cycle-counting"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-adjustment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-adjustment"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-cost-adjustment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-cost-adjustment"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-requisition',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-requisition"
        pageMode="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:CompanyID/company-setting/numbering-structure/stock-transfer-requisition',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="stock-transfer-requisition"
        pageMode="inventory-control"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/purchase-requisition',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="purchase-requisition"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/request-quotation',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="request-quotation"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/purchase-order',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="purchase-order"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/delivery-order',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="delivery-order"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/good-return-note',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="good-return-note"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/general-purchase/:CompanyID/company-settings/numbering-structure/refund',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="refund"
        pageMode="general-purchases"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-no',
    },
    component: (
      <AutoNumberingForm mode="add" DocType="asset" pageMode="fixed-assets" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-revaluation-no',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="asset-revaluation"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-count-no',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="asset-count"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/depreciation-no',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="depreciation"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/increase-value',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="increase-value"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/decrease-value',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="decrease-value"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/useful-life',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="useful-life"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/depreciation-method',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="depreciation-method"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/total-depreciation',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="total-depreciation"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/total-workload',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="total-workload"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/residual-value',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="residual-value"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/provision-impairment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="provision-impairment"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/provision-impairment-reversal',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="provision-impairment-reversal"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/asset-transfer-department',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="asset-transfer-department"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/change-asset-category',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="change-asset-category"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/change-apportionment',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="change-apportionment"
        pageMode="fixed-assets"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/company-setting/numbering-structure/asset-change/asset-transfer-location',
    },
    component: (
      <AutoNumberingForm
        mode="add"
        DocType="asset-transfer-location"
        pageMode="fixed-assets"
      />
    ),
  },
]

export default autoNumberingRoutes
